<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <left-side
      :status="leftSideStatus"
      :isHistoryData="isHistoryData"
      :rm_status_num="rmStatusNum"
      :rm_status="rmStatus"
      :status_id="filterProp.status"
      :key_codeType="filterProp.codeType"
      :key_code="filterProp.code"
      :key_isVague="filterProp.isVague"
      :key_name="filterProp.name"
      :key_id="filterProp.id"
      :key_timeType="filterProp.timeType"
      :key_timeCreatedFrom="filterProp.timeCreatedFrom"
      :key_timeCreatedTo="filterProp.timeCreatedTo"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :isHistoryData="isHistoryData"
        :isAccordion="isAccordionProduct"
        :check_arr="checkArr"
        :status_id="filterProp.status"
        :activeGroupName="activeGroupName"
        :key_codeType="filterProp.codeType"
        :key_code="filterProp.code"
        :key_name="filterProp.name"
        :key_timeType="filterProp.timeType"
        :key_timeCreatedFrom="filterProp.timeCreatedFrom"
        :key_timeCreatedTo="filterProp.timeCreatedTo"
        @accordionProducts="accordionProducts"
      />
      <div class="br-pagebody pd-lg-x-20 pd-sm-x-10" style="overflow: hidden">
        <router-view
          v-if="isSysRights('SupplierPurchaseOrder.findBySupplier')"
          :isHistoryData="isHistoryData"
          :first_loading="firstLoading"
          :loading="loading"
          :errorImg="errorImg"
          :items="items"
          :check_arr="checkArr"
          :isAccordion="isAccordionProduct"
          @popContact="popContact"
          @openModalTrack="openTrack"
        ></router-view>
        <no-rights v-else></no-rights>
        <pagination
          v-if="!firstLoading"
          :cur="filterProp.page"
          :all="totalPage"
          :path="
            $route.params.time
              ? '/RM-order-history/' + $route.params.time + '/'
              : '/RM-order/'
          "
          :size="7"
          :page_size_select="pageSizeSelect"
          :rows_per_page="rowsPerPage"
          :total_count="totalCount"
          @changeRPPage="changeRPPage"
          @gotoPage="toPage"
        ></pagination>
      </div>
    </div>
    <!-- 订单日志 -->
    <Popover
      :id="'orderLog'"
      :loading="popOrderLog.loading"
      v-show="
        $store.state.popover.id == 'orderLog' && $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'orderLog' && $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template v-if="popOrderLog.orderLog">
            <div
              class="
                d-flex
                align-items-center
                mg-b-5
                justify-content-sm-between
              "
            >
              <span>{{ $t("rm.操作日志：") }}</span>
              <a href="javascript:;" class="tx-info" @click="openOrderLog"
                >{{ $t("rm.查看更多") }}>></a
              >
            </div>
            <template v-for="(item, i) in popOrderLog.orderLog">
              <div
                class="d-flex align-items-center mg-b-5"
                :key="i"
                v-if="i < 3"
              >
                {{ item }}
              </div>
            </template>
          </template>
        </div>
      </template>
    </Popover>
    <!-- 物流信息 -->
    <Popover
      :id="'orderTrack'"
      :loading="popOrderTrack.loading"
      v-show="
        $store.state.popover.id == 'orderTrack' && $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'orderTrack' && $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template>
            <div class="d-flex align-items-center">
              <span class="tx-gray-900-7">{{ $t("order.单号") }}:</span>
              <a
                v-if="popOrderTrack.item.expressCode"
                href="javascript:;"
                class="mg-l-5 mg-r-10 tx-info"
                >{{ popOrderTrack.item.expressCode }}</a
              >
              <a
                v-if="popOrderTrack.item && popOrderTrack.item.expressCode"
                class="to-clipboard"
                href="javascript:;"
                :data-clipboard-text="popOrderTrack.item.expressCode"
              >
                <i class="icon ion-clipboard tx-info"></i>
              </a>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="
                popOrderTrack.status == 1 &&
                popOrderTrack.item.deliveryType != 2
              "
            >
              <span class="tx-gray-900-7">{{ $t("express.运费") }}:</span>
              <span class="mg-l-5 mg-r-10">
                {{ ($CE[popOrderTrack.obj.currency] || {}).symbol }}
                {{ popOrderTrack.item.shippingAmount }}</span
              >
              <a
                class="tx-info"
                href="javascript:;"
                v-if="popOrderTrack.item.isReceived != 1"
                @click="modifyOrderFreight(2)"
              >
                <i class="icon ion-edit tx-info"></i>
              </a>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="popOrderTrack.status == 2"
            >
              <span class="tx-gray-900-7">{{ $t("express.运费") }}:</span>
              <input
                class="mg-r-10 form-control form-control-sm wd-100"
                type="text"
                placeholder="$t('rm.输入运费')"
                v-model.trim="popOrderTrack.iptShipping"
                @keyup.enter="saveOrderFreight"
              />
              <a
                class="btn btn-primary btn-sm"
                href="javascript:;"
                @click="saveOrderFreight"
                >{{ $t("express.保存") }}</a
              >
            </div>
            <div class="d-flex align-items-center">
              <span class="tx-gray-900-7">{{ $t("rm.承运") }}:</span>
              <span class="mg-l-5 mg-r-10">
                {{ popOrderTrack.item.companyName }}</span
              >
            </div>
            <div class="d-flex align-items-center">
              <span class="tx-gray-900-7">{{ $t("order.发货") }}:</span>
              <span class="mg-l-5 mg-r-10">
                {{
                  popOrderTrack.item.deliverTime
                    ? popOrderTrack.item.deliverTime
                    : $t("rm.暂无发货时间")
                }}</span
              >
            </div>
            <div class="d-flex align-items-center">
              <span class="tx-gray-900-7">{{ $t("distributor.入库") }}:</span>
              <span class="mg-l-5 mg-r-10">
                {{
                  popOrderTrack.item.timeReceived
                    ? popOrderTrack.item.timeReceived
                    : $t("order.暂无入库时间")
                }}</span
              >
            </div>
            <div
              class="d-flex align-items-center mg-t-10"
              v-if="popOrderTrack.item.productInfo"
            >
              <span class="tx-gray-900-7"
                >{{ $t("distributor.包裹明细") }}:</span
              >
              <span class="mg-l-5 mg-r-10">
                <span class="tx-gray-900-7">{{ $t("rm.种类") }}</span>
                {{ popOrderTrack.item.productInfo.length
                }}{{ $t("distributor.种") }}
              </span>
              <span class="mg-l-5 mg-r-10">
                <span class="tx-gray-900-7">{{ $t("order.数量") }}</span>
                {{ popOrderTrack.allCnt }}{{ $t("order.件") }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <a
                href="javascript:;"
                class="tx-info mg-r-15"
                @click="
                  openTrack(popOrderTrack.obj, popOrderTrack.item.expressCode)
                "
                >{{ $t("distributor.查看包裹明细") }}</a
              >
            </div>
          </template>
        </div>
      </template>
    </Popover>
    <!-- 订单备注 -->
    <Popover
      :id="'orderRemark'"
      :loading="popOrderRemark.loading"
      v-show="
        $store.state.popover.id == 'orderRemark' && $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'orderRemark' && $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template v-if="popOrderRemark.orderRemark">
            <div
              class="
                d-flex
                align-items-center
                mg-b-5
                justify-content-sm-between
              "
            >
              <span>{{ $t("order.备注：") }}</span>
              <a
                href="javascript:;"
                class="tx-info"
                @click="openRemark(popOrderRemark.item)"
                >{{ $t("rm.查看更多") }}>></a
              >
            </div>
            <template v-for="(item, i) in popOrderRemark.orderRemark">
              <div
                :key="i"
                v-if="i < 3"
                class="d-flex align-items-center mg-b-5"
              >
                {{ item }}
              </div>
            </template>
          </template>
        </div>
      </template>
    </Popover>
    <!-- 订单日志 -->
    <modal-order-log :order_log="popOrderLog.orderLog" />
    <!-- 显示包裹信息 -->
    <modal-order-package
      :code="orderItem.code"
      :items="modalTrackNumber"
      :expressCode="modalTrackExpressCode"
    />
    <!-- 审核采购单 -->
    <modal-check-order :item="orderItem" />
    <!-- 关闭采购单 -->
    <modal-close-order :item="orderItem" />
    <!-- 填写包裹信息 -->
    <modal-write-packageinfo
      :item="orderItem"
      :product_info="orderItem.itemJson"
    />
    <!-- 填写入库数量 -->
    <modal-write-receipt-quantity
      :code="orderItem.code"
      :items="orderItem.trackNumberJson"
    />
    <!-- 修改采购价 -->
    <modal-edit-price :item="orderItem" />
    <!-- 修改采购数量 -->
    <modal-edit-num :item="orderItem" />
    <!-- 添加备注 -->
    <modal-order-remark :item="orderItem" />
    <!-- 导入采购单 -->
    <modal-import-order />
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
  </div>
</template>

<script>
import LeftSide from "./left-side";
import Header from "./header.vue";
import { pagination } from "@components/pagination.js"; //分页
import Popover from "@components/Popover.vue";
import ModalOrderLog from "./modal-order-log.vue";
import ModalCheckOrder from "./modal-check-order.vue";
import ModalCloseOrder from "./modal-close-order.vue";
import ModalWritePackageinfo from "./modal-write-packageinfo.vue";
import ModalWriteReceiptQuantity from "./modal-write-receipt-quantity.vue";
import ModalOrderPackage from "./modal-order-package.vue";
import ModalEditPrice from "./modal-edit-price.vue";
import ModalEditNum from "./modal-edit-num.vue";
import ModalOrderRemark from "./modal-order-remark.vue";
import ModalImportOrder from "./modal-import-order.vue";
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'

export default {
  components: {
    BatchSearchDialog,
    LeftSide,
    Header,
    pagination,
    Popover,
    ModalOrderLog,
    ModalCheckOrder,
    ModalCloseOrder,
    ModalWritePackageinfo,
    ModalWriteReceiptQuantity,
    ModalOrderPackage,
    ModalEditPrice,
    ModalEditNum,
    ModalOrderRemark,
    ModalImportOrder,
  },
  data() {
    return {
      loading: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      isHistoryData: this.$route.params.time ? true : false, //是否是历史数据
      selectedTime: this.$route.params.time
        ? this.$route.params.time
        : moment().subtract(3, "month").format("YYYY-MM"), //已选择的时间
      rmStatusNum: "",
      rmStatus: {
        1: { id: "1", name: this.$t("order.待审核") },
        2: { id: "2", name: this.$t("order.待发货") },
        3: { id: "3", name: this.$t("order.部分发货") },
        4: { id: "4", name: this.$t("order.已发货") },
        5: { id: "5", name: this.$t("rm.部分入库") },
        6: { id: "6", name: this.$t("transfer.已入库") },
        7: { id: "7", name: this.$t("order.已完成") },
        9: { id: "9", name: this.$t("order.取消") },
      },
      firstLoading: true,
      totalPage: 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("rm-order-rowsPerPage"))
        ? parseInt(store.get("rm-order-rowsPerPage"))
        : 10,
      totalCount: 0,
      items: [],
      checkArr: [],
      // 订单状态名
      activeGroupName: "",
      filterProp: {
        // 当前页数
        page: this.$route.params.page ? this.$route.params.page : 1,
        // 订单状态
        status: this.$route.query.status ? this.$route.query.status : "",
        // 编号类型,1=采购单号,2=物流单号,3=SKU编号,4=
        codeType: 1,
        code: "",
        // SKU模糊搜索
        isVague: "",
        // 供应商名称
        name: "",
        // 供应商id
        id: "",
        // 日期类型,1=采购日期,2=发货日期,3=入库日期
        timeType: 1,
        timeCreatedFrom: "",
        timeCreatedTo: "",
      },
      errorImg: {}, //错误的图片
      isAccordionProduct: store.get("isAccordionProduct-RM-order"),
      // 订单对象
      orderItem: {},
      // 订单日志参数
      popOrderLog: {
        loading: false,
        orderLog: "",
      },
      popOrderLogDefault: "",
      // 物流信息参数
      popOrderTrack: {
        loading: false,
        item: "",
        allCnt: 0,
        orderCode: "",
        status: 1,
        iptShipping: "",
        obj: "",
      },
      popOrderTrackDefault: "",
      // 备注信息参数
      popOrderRemark: {
        loading: false,
        orderRemark: "",
        item: "",
      },
      popOrderRemarkDefault: "",
      // 包裹信息列表
      modalTrackNumber: [],
      // 当前的物流单号
      modalTrackExpressCode: "",
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
    };
  },
  watch: {
    $route: function () {
      if (this.$route.params.time) {
        this.filterProp.status = "";
        this.isHistoryData = true;
        this.selectedTime = this.$route.params.time;
      } else {
        this.isHistoryData = false;
        this.selectedTime = moment().subtract(3, "month").format("YYYY-MM");
        this.getRMStatusNum();
      }
      if (this.$route.query.status) {
        this.$set(this.filterProp, "status", this.$route.query.status);
      }
      this.gotoPage();
    },
    rowsPerPage: function () {
      store.set("rm-order-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getRMOrder();
    this.getRMStatusNum();
    this.popOrderLogDefault = JSON.stringify(this.popOrderLog);
    this.popOrderTrackDefault = JSON.stringify(this.popOrderTrack);
    this.popOrderRemarkDefault = JSON.stringify(this.popOrderRemark);
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.filterProp.page = 1
      this.rowsPerPage = 10
      this.getRMOrder()
    },

    //todo
    // 获取物料采购单列表
    getRMOrder(type,batch) {
      if (!this.isSysRights("SupplierPurchaseOrder.findBySupplier")) return;
      if(batch == 'common') {
        this.batchBool = false
      }
      this.loading = true;
      let getData = (data) => {
        this.errorImg = {}; //重置不能载入的图片系列
        this.items = data.Results ? data.Results : [];
        this.totalPage = data.Pagination.totalPage;
        if (this.filterProp.page > this.totalPage) {
          this.filterProp.page = this.totalPage ? this.totalPage : 1;
          this.$router.push({ params: { page: this.filterProp.page } });
        }
        this.totalCount = data.Pagination.totalCount;
        if (!type) $("html,body").scrollTop(0);
        if (this.items && this.items.length > 0) {
          this.items.forEach((e, i) => {
            this.$set(e, "innerTableStatus", false);
          });
        }
        if (!this.isAccordionProduct) {
          setTimeout(() => {
            this.items.forEach((e, i) => {
              this.$set(e, "innerTableStatus", true);
            });
          }, 500);
        }
      };
      let params = {
          rowsPerPage: this.rowsPerPage,
          page: this.filterProp.page,
          status: this.filterProp.status,
          codeType: this.filterProp.codeType,
          code: this.filterProp.code,
          isVague: this.filterProp.isVague,
          rawSupplierId: this.filterProp.id,
          timeType: this.filterProp.timeType,
          timeCreatedFrom: this.filterProp.timeCreatedFrom,
          timeCreatedTo: this.filterProp.timeCreatedTo,
        }
        if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.filterProp.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call(
        "api.SupplierPurchaseOrder.findBySupplier",
        params,
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            getData(r.Data);
            if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 获取订单状态的统计数据
    getRMStatusNum() {
      if (!this.isSysRights("SupplierPurchaseOrder.findStatusCntBySupplier"))
        return;
      if (this.isHistoryData) {
        this.rmStatusNum = {};
        return;
      }
      let getData = (data) => {
        this.rmStatusNum = data;
      };
      let params = {};
      let url = "api.SupplierPurchaseOrder.findStatusCntBySupplier";
      let [year, month] = [
        this.selectedTime.split("-").shift().substring(2, 4),
        this.selectedTime.split("-").pop(),
      ];
      if (this.isHistoryData) (params.year = year), (params.month = month);
      $.api_call(url, params, function (r) {
        if (r.ErrorCode == "9999") {
          getData(r.Data.Results);
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    changeRPPage(num) {
      let page = this.filterProp.page;
      this.rowsPerPage = num;
      this.filterProp.page = 1;
      if (this.$route.params.time) {
        this.$router.push({
          path: `${this.$route.meta.url}/${this.$route.params.time}/1`,
        });
      } else {
        this.$router.push({ path: `${this.$route.meta.url}/1` });
      }
      if (page == 1) {
        this.getRMOrder();
      }
    },
    toPage(num) {
      let page = this.filterProp.page;
      if (this.$route.params.time) {
        this.$router.push({ params: { page: num } });
      } else {
        this.$router.push({ path: `${this.$route.meta.url}/${num}` });
      }
      if (page == num) {
        this.getRMOrder();
      }
    },
    gotoPage() {
      this.filterProp.page = this.$route.params.page
        ? this.$route.params.page
        : 1;
      this.getRMOrder();
    },
    // 商品折叠
    accordionProducts(type) {
      store.set("isAccordionProduct-RM-order", type);
      this.isAccordionProduct = type;
      if (!type) {
        this.items.forEach((e, i) => {
          this.$set(e, "innerTableStatus", true);
        });
      }
    },
    // 飘窗
    popContact(event, item, id, obj) {
      if (event.type == "mouseenter") {
        //打开
        this.$store.commit("setPopover", {
          id,
          event,
        });
        switch (id) {
          case "orderLog":
            this.popOrderLog = JSON.parse(this.popOrderLogDefault);
            this.popOrderLog.orderLog = item.orderLog;
            break;
          case "orderTrack":
            this.popOrderTrack = JSON.parse(this.popOrderTrackDefault);
            this.popOrderTrack.item = item;
            this.popOrderTrack.obj = obj;
            this.popOrderTrack.orderCode = item.expressCode;
            this.popOrderTrack.status = 1;
            let num = 0;
            if (item.productInfo && item.productInfo.length > 0) {
              item.productInfo.forEach((pro) => {
                num += Number(pro.deliveryCnt);
              });
            }
            this.popOrderTrack.allCnt = num;
            break;
          case "orderRemark":
            this.popOrderRemark = JSON.parse(this.popOrderRemarkDefault);
            this.popOrderRemark.orderRemark = item.orderRemark;
            this.popOrderRemark.item = item;
            break;
        }
      } else {
        this.$store.commit("setPopover", { event });
      }
    },
    // 显示更多操作日志
    openOrderLog() {
      $("#modalOrderLog").modal("show");
    },
    // 显示修改运费输入框
    modifyOrderFreight(status) {
      this.popOrderTrack.status = status;
      if (status == 2) {
        this.popOrderTrack.iptShipping = this.popOrderTrack.item.shippingAmount;
      }
    },
    // 修改运费
    saveOrderFreight() {
      let params = {
        code: this.popOrderTrack.obj.code,
        expressCode: this.popOrderTrack.item.expressCode,
        shippingAmount: this.popOrderTrack.iptShipping,
      };
      $.api_call(
        "api.SupplierPurchaseOrder.modifyShippingInfo",
        params,
        (r) => {
          if (r.ErrorCode == "9999") {
            this.popOrderTrack.item.shippingAmount =
              this.popOrderTrack.iptShipping;
            this.popOrderTrack.status = 1;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 显示包裹信息
    openTrack(item, code, type) {
      this.modalTrackNumber = [];
      if (type == "popover") {
        this.modalTrackNumber.push(this.popOrderTrack.item);
      } else {
        this.modalTrackNumber = item.trackNumberJson;
      }
      this.modalTrackExpressCode = code;
      this.orderItem = item;
      $("#modalOrderPackage").modal("show");
    },
    // 打开备注
    openRemark(item) {
      this.orderItem = item;
      $("#modalOrderRemark").modal("show");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>